import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { find, maxBy, isEqual, cloneDeep } from 'lodash';

import config from '../../../config/config';
import Box from '../../common/Box';
import CSV from '../../../helpers/CSVExport';
import ModeSelect from '../../common/ModeSelect';
import BarChart from '../../widgets/charts/types/BarChartWithAnnotations';
import LineChart from '../../widgets/charts/types/LineChartWithAnnotations';

const lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
const tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
const barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
const downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');


class MetricChart extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
		  mode: props.defaultMode || "line",
		};
		this.setMode = this.setMode.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
	}

	setMode(mode){
		this.setState({mode}, ()=>{
		});
	}
	
	exportToCsv(){
		const { data, metric } = this.props;
		let result = [];
		const dataset = find(data.datasets, row=>row.id == metric);
		for(let index in data.labels) {
			result.push({
				period: data.labels[index],
				units: dataset.data[index],
			})
		}
		const filename = CSV.CSVHeader('Spotify Discovery', metric);
		return CSV.CSVExport(result, {filename});
	}
	
	renderToolbar(){
		let toolbar = [];
		const options = [
			{icon: barSvg, value: 'bar', label: "Bar Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			//{icon: tableSvg, value: 'table', label: "Table"},
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
		<div className="ibox-icon-holder mode-select">
			<ModeSelect options={options} selected={this.state.mode} onChange={this.setMode} isSearchable={ false } />
		</div>
		<div className="ibox-actions">
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />	
		</div>
		</div>)
		return toolbar;
	}
	
	render (){
		const { metric, title, loading, data, ...rest } = this.props;
		const datasets = (data && data.datasets) ? data.datasets.filter(row=>row.id == metric) : null;
		const { mode } = this.state;
		
		return <Box title={title} spinnerEnabled={loading} toolbar={this.renderToolbar()} >
			{datasets && <div className="chart-block">
				{mode == 'line' && <LineChart shadowChart={true} shadowChartHeight={300} data={{labels: data.labels, datasets}} id={`spotify_discovery_metrics_${metric.toLowerCase()}`} period={this.props.period} dateGroup={this.props.period} filteredLogVendors={['spotify']} {...rest}  />}
				{mode == 'bar' && <BarChart shadowChart={true} shadowChartHeight={300} data={{labels: data.labels, datasets}} id={`spotify_discovery_metrics_${metric.toLowerCase()}`} filteredLogVendors={['spotify']} {...rest} />}

			</div>}
		</Box>
	}
}

export default MetricChart;